import StandaloneSpecialtyEventUploadView from './StandaloneSpecialtyEventUploadView';

export default StandaloneSpecialtyEventUploadView;
